<div class="flex flex-col gap-2">
  @if (items().length) {
    <ul class="flex flex-col gap-1">
      @for (item of items(); track $index) {
        <li class="flex items-start gap-2 rounded-md border border-neutral-100 px-3 py-2 text-sm">
          <span class="flex-1 text-neutral-700">{{ item }}</span>
          <button
            type="button"
            class="hover:text-error-600 flex items-center text-neutral-400"
            [attr.aria-label]="'protocols.edit.remove' | translate"
            (click)="remove($index)"
          >
            <mat-icon style="font-size: 1.1rem; width: 1.1rem; height: 1.1rem">close</mat-icon>
          </button>
        </li>
      }
    </ul>
  }

  <div class="flex items-center gap-2">
    <input
      class="form-input w-full rounded-md border border-neutral-200 px-3 py-2 text-sm"
      type="text"
      [value]="draft()"
      [placeholder]="'protocols.edit.addText' | translate"
      (input)="onInput($event)"
      (keydown.enter)="$event.preventDefault(); add()"
    />
    <button
      type="button"
      class="btn btn-secondary shrink-0"
      (click)="add()"
    >
      {{ "protocols.coverage.add" | translate }}
    </button>
  </div>
</div>
